(function () {
  async function addToCart(variantId, qty) {
    const id = Number(variantId);
    if (!id) throw new Error('Variant ID missing');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      cache: 'no-store',
      body: JSON.stringify({ id, quantity: qty || 1 })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function refreshCartUI() {
    // Ajusta si tu tema usa otros handles de sección
    const sectionHandles = ['cart-drawer','cart-icon-bubble'];
    const url = `${window.location.pathname}?sections=${sectionHandles.join(',')}`;

    const res = await fetch(url, { headers: {'Accept':'application/json'}, cache: 'no-store' });
    const data = await res.json();

    // Drawer
    const drawerEl = document.querySelector('cart-drawer, .cart-drawer, .cart-sidebar, .side-cart');
    if (drawerEl && data['cart-drawer']) {
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const newInner = html.body.firstElementChild ? html.body.firstElementChild.innerHTML : html.body.innerHTML;
      drawerEl.innerHTML = newInner;
    }

    // Burbuja/contador
    const bubble = document.querySelector('[data-cart-count-bubble], .cart-count-bubble, [data-header-cart-count]');
    if (bubble && data['cart-icon-bubble']) {
      const bubbleHTML = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const fresh = bubbleHTML.body.firstElementChild || bubbleHTML.body;
      bubble.replaceWith(fresh);
    }
  }

  function openDrawer() {
    const drawer = document.querySelector('cart-drawer, .cart-drawer, .cart-sidebar, .side-cart');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    drawer?.classList.add('is-open');
    document.querySelector('[data-open-cart-drawer], .js-open-cart-drawer')?.click();
  }

  async function handleAddClick(btn, e) {
    e.preventDefault();
    btn.disabled = true;

    let variantId = btn.dataset.variantId;
    if (!variantId) {
      const scope = btn.closest('.product-card, .product-grid_card, .product-card__form, form') || document;
      variantId = scope.querySelector('input[name="id"]')?.value;
    }

    try {
      await addToCart(variantId, 1);
      await refreshCartUI();
      openDrawer();
    } catch (err) {
      console.error('No se pudo agregar:', err);
    } finally {
      btn.disabled = false;
    }
  }

  // Click en el botón “Agregar”
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-card-add, .product-card__form .button');
    if (!btn) return;
    handleAddClick(btn, e);
  });

  // Por si el botón quedó como type="submit"
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.product-card__form');
    if (!form) return;
    const btn = form.querySelector('.js-card-add') || form.querySelector('button[type="submit"]');
    if (btn) handleAddClick(btn, e);
  });
})();
